import React, { useState, useEffect } from 'react';
import { Box, TextField, Container, Grid, Card, CardContent, Divider, Button, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';

const EditVOD = (props) => {
  const defaultFormValues = {
    id: '',
    title: '',
    displayName: '',
    directoryPath: '',
    active: false,
    price: '',
    discount: '',
  };

  const [formValues, setFormValues] = useState(defaultFormValues);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.id]: e.target.value });
  };

  const handleClose = () => {
    props.handleClose();
  };

  const updateVOD = async (data) => {
    try {
      const response = await axios.put(`${process.env.REACT_APP_BASE_API_URL}/vod/${data.id}`, data);
      return response.data;
    } catch (error) {
      if (error.response) {
        setError(error.response.data.message || 'Something went wrong!');
      } else if (error.request) {
        setError('Request was made but no response received!');
      } else {
        setError('Error setting up the request!');
      }
      return null;
    }
  };

  const onUpdate = async () => {
    setError('');
    const response = await updateVOD(formValues);
    if (response) {
      props.handleClose();
    } else {
      setError('Failed to update VOD. Please try again.');
    }
  };

  useEffect(() => {
    if (props.vodData) {
      setFormValues({
        id: props.vodData.id || '',
        title: props.vodData.title || '',
        displayName: props.vodData.displayName || '',
        directoryPath: props.vodData.directoryPath || '',
        active: props.vodData.active || false,
        price: props.vodData.price || '',
        discount: props.vodData.discount || '',
      });
    } else {
      setFormValues(defaultFormValues);
    }
  }, [props.vodData]);

  return (
    <>
      <Helmet>
        <title>Edit VOD</title>
      </Helmet>
      <Container maxWidth="lg" sx={{ paddingBottom: '25px' }}>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Card>
              <Divider />
              <CardContent>
                <Box sx={{ paddingBottom: '20px' }}>
                  <Box
                    sx={{
                      paddingBottom: '20px',
                      boxShadow: 0,
                      p: 1,
                      m: 1,
                      borderRadius: 2,
                      textAlign: 'center',
                    }}
                  >
                    <Grid
                      container
                      rowSpacing={1}
                      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                    >
                      <Grid item xs={6}>
                        <TextField
                          required
                          id="id"
                          value={formValues.id}
                          label="ID"
                          fullWidth
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          required
                          id="title"
                          value={formValues.title}
                          label="Title"
                          fullWidth
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          required
                          id="displayName"
                          value={formValues.displayName}
                          label="Display Name"
                          fullWidth
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          required
                          id="directoryPath"
                          value={formValues.directoryPath}
                          label="Directory Path"
                          fullWidth
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          required
                          id="active"
                          value={formValues.active}
                          label="Active"
                          fullWidth
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          required
                          id="price"
                          value={formValues.price}
                          label="Price"
                          fullWidth
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          required
                          id="discount"
                          value={formValues.discount}
                          label="Discount"
                          fullWidth
                          onChange={handleChange}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  {error && (
                    <Typography variant="body2" color="error">
                      {error}
                    </Typography>
                  )}
                  <Box sx={{ float: 'right', paddingBottom: '20px', paddingTop: '15px' }}>
                    <Button sx={{ marginInline: '8px' }} onClick={handleClose} variant="contained">
                      Cancel
                    </Button>
                    <Button onClick={onUpdate} variant="contained">
                      Update
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default EditVOD;
